// extracted by mini-css-extract-plugin
export default {"main":"marketPlaces_main__miiYe","checkbox":"marketPlaces_checkbox__YNsSd","item":"marketPlaces_item__PFdcj","label":"marketPlaces_label__UD0GN"};